// extracted by mini-css-extract-plugin
export default {"row":"ImageLabel_row__8rVUz","image_container":"ImageLabel_image_container__xsGyw","image":"ImageLabel_image__4lLzP"};